import { Container, Text } from '@chakra-ui/react';
import NextImage from 'next/legacy/image';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Section } from '@/components/ui/core/Section/Section';

export const LibraryHeader: FC = () => {
  const { t } = useTranslation();

  return (
    <Section height={{ base: '260px', md: '368px' }} position="relative">
      <NextImage
        src="/images/library/landingHeroBg.png"
        layout="fill"
        objectFit="cover"
        objectPosition="center 45%"
        role="presentation"
        loading="eager"
        priority
      />

      <Container pt={{ base: '4.5rem', md: '4rem', lg: '3.5rem' }} px={{ base: 5, md: 10, lg: 5 }} zIndex={2}>
        <Text as="h1" color="white" textStyle="grotesk4XL" textTransform="uppercase" whiteSpace="pre-line">
          {t('library.heading')}
        </Text>
      </Container>
    </Section>
  );
};
